import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import Marquee from 'react-fast-marquee'
import { animeSchedule } from '../../services/images.service'

export function NewestPostsFooter() {
  const posts = useSelector((state) => state.postModule.posts)

  const recentPosts = useMemo(() => {
    if (!Array.isArray(posts)) return []
    return posts
      .filter((post) => post?._id)
      .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
      .slice(0, 6)
  }, [posts])

  if (!recentPosts.length) return null

  const postItems = recentPosts.map((post) => (
    <span key={post._id} className="mx-4">
      <Link to={`/post/${post._id}`} className="hover:underline text-white">
        {post.title}
      </Link>
    </span>
  ))

  // הוספת Red Dot כאלמנט מפריד בין כל כותרת
  const spacedPostItems = postItems.reduce((acc, item, idx) => {
    acc.push(item)
    if (idx < postItems.length - 1) {
      acc.push(
        <img
          src={animeSchedule.redDot}
          key={`reddot-${idx}`}
          alt="Red Dot"
          className="mx-2"
        />
      )
    }
    return acc
  }, [])

  return (
    <div className="p-4 overflow-hidden flex items-center">
      <div className="flex-1 overflow-hidden">
        {/* Marquee רץ אינסופי עם הכפלת הטקסט במקרה הצורך */}
        <Marquee
          gradient={false}
          speed={33}           // מהירות באנימציה (ניתן לשנות בהתאם לצורך)
          autoFill={true}      // הכפלת הטקסט כדי למלא את הרווח
          loop={0}             // 0 = אינסוף לולאות
          play={true}
          pauseOnHover={false}
          pauseOnClick={false}
          direction="left"
          delay={0}
        >
          {spacedPostItems}
        </Marquee>
      </div>
    </div>
  )
}

export default NewestPostsFooter
